<!-- TABS -->
<button type="button" mat-raised-button (click)="goBack()">
    <mat-icon>chevron_left</mat-icon>
</button>

<mat-tab-group #tabGroup>

    <!-- COMPOSE -->
    <mat-tab label="Compose">
        <div class="body-content">

            <h4 class="text-center margin-1rem">Compose New Message</h4>

            <div class="composer-container">
                <div class="actions">
                    <!-- CATEGORIES -->
                    <mat-form-field class="col-md-9" *ngIf="templateCategories">
                        <mat-label>Template Categories</mat-label>
                        <mat-select [(ngModel)]="emailConfig.templateCategory" (selectionChange)="onSelectCategory($event)" required name="category">
                            <mat-option *ngFor="let category of templateCategories" [value]="category.id">
                                <i [class]="category.icon"></i>
                                {{category.label}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <!-- SHOW PREVIEW -->
                    <button type="button" class="cta-button" *ngIf="showPreviewButton()" (click)="showHidePreviewEmail()">Preview email</button>
                </div>
        
                <!-- TEMPLATE SELECTOR -->
                <div class="form-group mt-3" *ngIf="emailConfig.templateCategory">
                    <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 20px;">
                        <mat-label>Email template</mat-label>
                        <mat-select [(ngModel)]="emailConfig.selectedTemplate" (selectionChange)="onTemplateSelection($event)" required name="template">
                            <mat-option *ngFor="let template of emailConfig.templates" [value]="template">{{template.label}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div>
                    <!-- DEPENDENCY -->
                    <div #dynamicContainer></div>
                </div>

                <!-- DYNAMIC FORM FIELDS -->
                <form *ngIf="emailConfig.selectedTemplate && isQueryResolved(emailConfig.selectedTemplate) && isDependsOfResolved(emailConfig.selectedTemplate)" >
                    <div *ngFor="let field of (getRequiredFields(emailConfig.selectedTemplate) | keyvalue)">
                        <!-- INPUT -->
                        <mat-form-field *ngIf="field.value.fieldType == 'input'" appearance="fill" class="form-field">
                            <mat-label>
                                <i *ngIf="field.value?.icon" [class]="field.value.icon" style="margin-right: 8px;"></i>
                                {{ field.key | titlecase }}
                                <span *ngIf="field.value?.mandatory" style="color: red;">*</span>
                            </mat-label>
                            <input matInput type="text" [placeholder]="'Enter ' + field.key" [value]="formData[field.key]" (input)="updateField(field.key, $event.target.value)"/>
                        </mat-form-field>
                        <!-- TEXT AREA -->
                        <mat-form-field *ngIf="field.value.fieldType == 'textarea'" appearance="fill" class="form-field">
                            <i *ngIf="field.value?.icon" [class]="field.value.icon" style="margin-right: 8px;"></i>
                                {{ field.key | titlecase }}
                                <span *ngIf="field.value?.mandatory" style="color: red;">*</span>
                            <textarea matInput [placeholder]="'Enter ' + field.key" [value]="formData[field.key]"></textarea>
                        </mat-form-field>
                    </div>
                </form>

                <!-- <form *ngIf="emailConfig.selectedTemplate">
                    <div *ngFor="let field of (getRequiredFields(emailConfig.selectedTemplate) | keyvalue)">
                        <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 20px;">
                        <mat-label>
                            <i *ngIf="field.value?.icon" [class]="field.value.icon" style="margin-right: 8px;"></i>
                            {{ field.key | titlecase }}
                            <span *ngIf="field.value?.mandatory" style="color: red;">*</span>
                        </mat-label>
                        <input
                            matInput
                            type="text"
                            [placeholder]="'Enter ' + field.key"
                            [value]="formData[field.key]"
                            (input)="updateField(field.key, $event.target.value)"
                        />
                        </mat-form-field>
                    </div>
                </form> -->
                

        
            </div>

        </div>
    </mat-tab>

    <!-- PREVIEW -->
    <mat-tab label="Preview" *ngIf="showEmailPreviewSection()">
        <div class="content">
            <div class="email-composer-header">
                <h3>Email preview</h3>
            </div>

            <app-email-preview [emailFormData]="" [config]="emailConfig"></app-email-preview>
        </div>
    </mat-tab>
    
    <!-- CONFIG -->
    <mat-tab label="Config" *ngIf="showEmailPreviewSection()">
        <div class="content">
            <div class="email-composer-header">
                <h3>Email configuration</h3>
            </div>
            <div class="email-composer-container">

                <div class="email-summary" *ngIf="areAllFieldsNotNull(formData)">
                    <div class="field" *ngFor="let field of formData | keyvalue">
                        <i [class]="getIconClass(field.key)"></i>
                        <span class="label">{{ field.key | titlecase }}:</span>
                        <span class="value">{{field.value}}</span>
                    </div>
                    
                    </div>

                <div class="d-flex flex-column">

                    <div class="form-group">
                        <label for="cc">
                            <i class="fas fa-copy"></i> CC:
                        </label>
                        <input type="email" id="cc" name="cc" placeholder="Add CC recipients (optional)" />
                    </div>

                    <!-- INLCUDE COMPANY CC's -->
                    <div class="form-group">
                        <mat-slide-toggle [checked]="">Company CC</mat-slide-toggle>
                    </div>
                    
                    <!-- INLCUDE COMPANY BCC's -->
                    <div class="form-group">
                        <label for="bcc">
                            <i class="fas fa-user-secret"></i> BCC:
                        </label>
                        <input type="email" id="bcc" name="bcc" placeholder="Add BCC recipients (optional)" />
                    </div>

                    <!-- Additional Settings -->
                    <div class="form-group">
                        <label for="attachments">
                            <i class="fas fa-paperclip"></i> Attachments:
                        </label>
                        <input type="file" id="attachments" name="attachments" multiple />
                    </div>

                </div>
            </div>
        </div>
    </mat-tab>
    
    <!-- SEND -->
    <mat-tab label="Send">
        <div class="content">
            <div class="email-composer-header">
                <h3>Send email</h3>
            </div>
            <div class="email-composer-container">

                <!-- Action Buttons -->
                <div class="form-actions" *ngIf="!loading">
                    <button type="submit" class="btn btn-primary" *ngIf="showEmailPreviewSection()" (click)="sendEmail()">
                        <i class="fas fa-paper-plane"></i> Send
                    </button>
                    <button type="reset" class="btn btn-danger" (click)="clearData()">
                        <i class="fas fa-trash"></i> Clear
                    </button>
                </div>
                <!-- Spinner -->
                <mat-spinner [diameter]="50" class="dark-button-spinner center" *ngIf="loading"></mat-spinner>

            </div>
        </div>
    </mat-tab>
</mat-tab-group>